// src/pages/Careers.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getJobRoles } from '../api/careersApi';
import LoadingSpinner from '../components/LoadingSpinner';
import './Careers.css';

const Careers = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      const res = await getJobRoles(true); // only active jobs
      setJobs(res.data || []);
    } catch (err) {
      console.error('Error fetching jobs:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="careers-container">
      <h2 className="careers-title">Careers at Talyfax</h2>
      <p className="careers-subtitle">
        Join our team and help us build the future. Explore our open roles below.
      </p>

      {loading ? (
        <LoadingSpinner />
      ) : jobs.length ? (
        <div className="jobs-list">
          {jobs.map((job) => (
            <div key={job.id} className="job-card">
              <div className="job-card-header">
                <h3>{job.title}</h3>
                <span className="job-type">{job.type || 'Full-time'}</span>
              </div>

              <div className="job-meta">
                <span><strong>Location:</strong> {job.location || 'Remote'}</span>
                {job.salary && <span><strong>Salary:</strong> {job.salary}</span>}
              </div>

              {/* Show only 2-3 key requirements */}
              {job.requirements && (
                <ul className="job-requirements">
                  {job.requirements
                    .split('\n') // assuming requirements are newline separated
                    .slice(0, 2) // take first 2 requirements only
                    .map((req, idx) => (
                      <li key={idx}>{req}</li>
                    ))}
                  {job.requirements.split('\n').length > 2 && (
                    <li>...</li>
                  )}
                </ul>
              )}

              <Link to={`/careers/${job.id}`} className="details-link">
                View Details
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <p>No job openings available right now. Check back later!</p>
      )}
    </div>
  );
};

export default Careers;
